import React, { Component } from "react";
import "./ArenaLabNav.css";
import ToggleSwitch from "../../components/ToggleSwitch/ToggleSwitch";
import StyleContext from "../../contexts/StyleContext";

class ArenaLabNav extends Component {
  static contextType = StyleContext;

  constructor(props) {
    super(props);
    this.state = {
      isScrolled: false
    };
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll = () => {
    if (window.scrollY > 50) {
      this.setState({ isScrolled: true });
    } else {
      this.setState({ isScrolled: false });
    }
  };

  scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  render() {
    const { isDark, changeTheme } = this.context;
    const { isScrolled } = this.state;

    return (
      <nav className={`arena-lab-nav ${isScrolled ? "scrolled" : ""}`}>
        <div className="arena-lab-nav-content">
          <div className="arena-lab-nav-logo">
            <a href="#/" className="nav-logo-link">
              <span className="arena-text">ARENA Lab</span>
            </a>
          </div>

          <div className="arena-lab-nav-links">
            <button onClick={() => this.scrollToSection("news")} className="nav-link">
              News
            </button>
            <button onClick={() => this.scrollToSection("team")} className="nav-link">
              Team
            </button>
            <button onClick={() => this.scrollToSection("publications")} className="nav-link">
              Publications
            </button>
            <button onClick={() => this.scrollToSection("opportunities")} className="nav-link">
              Opportunities
            </button>
            <button onClick={() => this.scrollToSection("projects")} className="nav-link">
              Projects
            </button>
            <button onClick={() => this.scrollToSection("events")} className="nav-link">
              Events
            </button>
            <a href="#/" className="nav-link home-link">
              ← Portfolio
            </a>
            <ToggleSwitch theme={isDark ? "dark" : "light"} onToggle={changeTheme} />
          </div>
        </div>
      </nav>
    );
  }
}

export default ArenaLabNav;
